// extracted by mini-css-extract-plugin
module.exports = {"root":"x4BKb","transform":"_1F9Tn","swipeable":"_2CZf2","preview":"_2vTAB","next":"_1xBLE","prev":"KAGCD"};